export const FEATURE_FLAG = Object.freeze({
  WORKDAY: { flag: 'workday', persist: true },
});